import React from 'react';
import { Loader2, Save } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Input } from '../../../ui/input';
import { Label } from '../../../ui/label';
import { Textarea } from '../../../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../ui/dialog';

const Field = ({ label, children }) => (
  <div>
    <Label>{label}</Label>
    {children}
  </div>
);

export const BrandDialog = ({ open, onOpenChange, brand, setBrand, onSave, saving }) => {
  const set = (key) => (e) => setBrand(prev => ({ ...prev, [key]: e.target.value }));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="brand-dialog">
        <DialogHeader>
          <DialogTitle>{brand?.id ? 'Edit Brand' : 'Add New Brand'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <Field label="Brand Name *">
            <Input value={brand?.name || ''} onChange={set('name')} placeholder="e.g., Coulisse, Hunter Douglas" className="mt-1" data-testid="brand-name-input" />
          </Field>
          <Field label="Website">
            <Input value={brand?.website || ''} onChange={set('website')} placeholder="https://www.example.com" className="mt-1" />
          </Field>
          <Field label="Logo URL">
            <Input value={brand?.logo_url || ''} onChange={set('logo_url')} placeholder="https://..." className="mt-1" />
          </Field>
          <Field label="Description">
            <Textarea value={brand?.description || ''} onChange={set('description')} placeholder="Brief description of the brand" className="mt-1" rows={3} />
          </Field>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} disabled={saving} className="bg-amber-600 hover:bg-amber-700" data-testid="brand-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}
            Save Brand
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BrandDialog;
